import { NgModule } from '@angular/core';

import { DashboardCoursesModule } from '../dashboard-courses/dashboard-courses.module';
import { DashboardWidgetsModule } from '../dashboard-widgets/dashboard-widgets.module';
import { SharedModule } from '../shared';

import { DashboardComponent } from './dashboard.component';
import { DashboardRouting } from './dashboard.routing';

@NgModule({
    imports: [
        DashboardWidgetsModule,
        DashboardCoursesModule,
        SharedModule,
        DashboardRouting
    ],
    declarations: [
        DashboardComponent
    ]
})
export class DashboardModule { }
